export const STEPS = {
    PASSENGERS: 'passengers',
    SEATS: 'seats',
    BAGGAGE: 'baggage',
    MEAL: 'meal',
    SERVICES: 'services',
    PAYMENT: 'payment',
    SUMMARY: 'summary',
};
